/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_GeneratingInputs */

const en_interview_prepare_generating = /** @type {(inputs: Interview_Prepare_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating...`)
};

const de_interview_prepare_generating = /** @type {(inputs: Interview_Prepare_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird generiert...`)
};

const fr_interview_prepare_generating = /** @type {(inputs: Interview_Prepare_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération en cours...`)
};

const es_interview_prepare_generating = /** @type {(inputs: Interview_Prepare_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando...`)
};

const it_interview_prepare_generating = /** @type {(inputs: Interview_Prepare_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione...`)
};

const nl_interview_prepare_generating = /** @type {(inputs: Interview_Prepare_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereren...`)
};

const pl_interview_prepare_generating = /** @type {(inputs: Interview_Prepare_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generowanie...`)
};

const fi_interview_prepare_generating = /** @type {(inputs: Interview_Prepare_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luodaan...`)
};

const da_interview_prepare_generating = /** @type {(inputs: Interview_Prepare_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genererer...`)
};

const sv_interview_prepare_generating = /** @type {(inputs: Interview_Prepare_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genererar...`)
};

/**
* | output |
* | --- |
* | "Generating..." |
*
* @param {Interview_Prepare_GeneratingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_generating = /** @type {((inputs?: Interview_Prepare_GeneratingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_GeneratingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_generating(inputs)
	if (locale === "fr") return fr_interview_prepare_generating(inputs)
	if (locale === "es") return es_interview_prepare_generating(inputs)
	if (locale === "it") return it_interview_prepare_generating(inputs)
	if (locale === "nl") return nl_interview_prepare_generating(inputs)
	if (locale === "pl") return pl_interview_prepare_generating(inputs)
	if (locale === "fi") return fi_interview_prepare_generating(inputs)
	if (locale === "da") return da_interview_prepare_generating(inputs)
	if (locale === "sv") return sv_interview_prepare_generating(inputs)
	return en_interview_prepare_generating(inputs)
});